import { Link, useLocation } from "react-router-dom";

const ITEMS = [
  { to: "/", label: "首页", icon: "ri-home-5-line" },
  { to: "/movies", label: "分类", icon: "ri-movie-2-line" },
  { to: "/search", label: "搜索", icon: "ri-search-line" },
  { to: "/news", label: "资讯", icon: "ri-newspaper-line" },
  { to: "/favorites", label: "我的收藏", icon: "ri-bookmark-line" },
];

export default function BottomNav() {
  const { pathname } = useLocation();

  const isActive = (to: string) => {
    if (to === "/") return pathname === "/";
    if (to === "/movies") return pathname === "/movies" || pathname === "/tvseries";
    return pathname.startsWith(to);
  };

  return (
    <nav className="fixed inset-x-0 bottom-0 z-50 border-t border-background-200 bg-background-50/95 backdrop-blur md:hidden">
      <ul className="grid grid-cols-5">
        {ITEMS.map((item) => {
          const active = isActive(item.to);
          return (
            <li key={item.to}>
              <Link
                to={item.to}
                className={`flex flex-col items-center gap-0.5 py-2 text-[11px] font-medium transition-colors ${
                  active ? "text-accent-600" : "text-foreground-500"
                }`}
              >
                <span className="flex h-6 w-6 items-center justify-center text-xl">
                  <i className={item.icon}></i>
                </span>
                <span className="whitespace-nowrap">{item.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}